import type { RouteObject } from 'react-router-dom'
import { useLocation, useRoutes } from 'react-router-dom'
import ErrorBoundary from '@/components/ErrorBoundary'
import ScrollToTop from '@/components/ScrollToTop'
import Home from '@/pages/Home'
import HowItWorks from '@/pages/HowItWorks'
import Launchpad from '@/pages/Launchpad'
import MyColony from '@/pages/MyColony'
import ColonyProfile from '@/pages/ColonyProfile'
import ColonyNewsfeed from '@/pages/ColonyNewsfeed'
import ExploreColony from '@/pages/ExploreColony'
import NotFound from '@/pages/NotFound'
import Presale from '@/pages/Presale'
import PresaleVsQuickLaunch from '@/pages/PresaleVsQuickLaunch'
import ProjectDetail from '@/pages/ProjectDetail'
import SubmitProject from '@/pages/SubmitProject'
import Disclaimer from '@/pages/Disclaimer'
import Terms from '@/pages/Terms'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/launchpad', element: <Launchpad /> },
  { path: '/launchpad/:id', element: <ProjectDetail /> },
  { path: '/presale', element: <Presale /> },
  { path: '/presale/:id', element: <ProjectDetail /> },
  { path: '/how-it-works', element: <HowItWorks /> },
  { path: '/presale-vs-quick-launch', element: <PresaleVsQuickLaunch /> },
  { path: '/my-colony', element: <MyColony /> },
  { path: '/explore-colony', element: <ExploreColony /> },
  { path: '/colony-newsfeed', element: <ColonyNewsfeed /> },
  { path: '/colony/:wallet', element: <ColonyProfile /> },
  { path: '/submit', element: <SubmitProject /> },
  { path: '/terms', element: <Terms /> },
  { path: '/disclaimer', element: <Disclaimer /> },
  { path: '/:slug', element: <ProjectDetail /> },
  { path: '*', element: <NotFound /> },
]

function App() {
  const element = useRoutes(routes)
  const location = useLocation()
  return (
    <>
      <ScrollToTop />
      <ErrorBoundary key={location.pathname}>
        {element}
      </ErrorBoundary>
    </>
  )
}

export default App
